import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { AssessmentQuestionBase } from "../models/assessment-question-base.model";
import { FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import { FormService } from "../../form/form.service";


@Component({
    selector: 'textentry-question',
    templateUrl: './textentry-question.component.html',
    styleUrls: ['./textentry-question.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextEntryQuestionComponent),
            multi: true
        }
    ],
    standalone: false
})
  export class TextEntryQuestionComponent {
    @Input() question: any;    
    @Input('value') _value: any;
    @Input() disabled_: boolean = false;
    @Output() valueChange = new EventEmitter<any>();
    propagateChange = (_: any) => { };
    onTouched: any = () => { };
  
    constructor() {
    }
    ngOnInit() {
        console.log("TextEntry Question",this.question);
    }

   
    get value(): any {
      return this._value;
    }
  
    set value(val) {
      this._value = val;
      this.propagateChange(val);
      this.onTouched();
    }
  
    writeValue(value) {
      if (value != undefined || value != '') {
        this.value = value;
        this.setvalueForUpdate(this.value);
      } else {
        this.value = "";
      }
      this.propagateChange(value);
    }
  
    setvalueForUpdate(value) {
    }
    registerOnChange(fn: any) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
  }